import { checkIsBusinessUser } from './util/checkIsBusinessUser'
import { ACTIONS } from './actions'

export type User = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  accounts?: any[]
  email: string
  name: {
    firstName: string
    lastName: string
    companyName: string | null
  }
  isBusinessUser?: boolean
  organisationId?: string
  parcelShopPsfKey?: string
  parcelShopServices: ParcelShopService[]
  userId: string
  timeLastNewsRead?: string
}

export enum ParcelShopService {
  Printless = 'printless',
  OTC = 'otc',
  SPA = 'spa',
}

export type AccountStateType = {
  user: User
  isInitialUserCheckDone?: boolean
  isLoggedIn: boolean | null
  loggedInWithBusinessAccount?: boolean
}

export const emptyUser = {
  name: {
    firstName: '',
    lastName: '',
    companyName: '',
  },
  email: '',
  accounts: [],
  userId: '',
  parcelShopServices: [],
}

export const initState: AccountStateType = {
  user: emptyUser,
  isLoggedIn: null,
  loggedInWithBusinessAccount: false,
}

// eslint-disable-next-line @typescript-eslint/default-param-last, @typescript-eslint/no-explicit-any
export const accountReducer = (state: AccountStateType = initState, { type, payload }: any): AccountStateType => {
  switch (type) {
    case ACTIONS.INITIAL_USER_CHECK_DONE:
      return {
        ...state,
        isInitialUserCheckDone: true,
      }
    case ACTIONS.LOGIN_SUCCESS:
      return {
        ...state,
        user: payload.user,
        isLoggedIn: true,
        loggedInWithBusinessAccount: checkIsBusinessUser(payload.user),
      }
    case ACTIONS.LOGOUT:
    case ACTIONS.EXPIRED:
      return {
        ...initState,
        isLoggedIn: false,
      }
    default:
      return state
  }
}
